// Minimal client-side navigation: push a URL and let the shell re-render.
export function navigate(url: string) {
  if (url !== window.location.pathname + window.location.search) {
    history.pushState(null, '', url);
  }
  window.dispatchEvent(new PopStateEvent('popstate'));
}

/** Replaces the current URL without adding a history entry. */
export function replaceUrl(url: string) {
  history.replaceState(null, '', url);
}
